import _ from 'lodash';
import globalStore from '$$globalStore';
import userCustomColumnsComponent from '../../../components/userCustomColumns';

export default function (instance, ganttData) {
  instance.ganttDataApi.getProjectColumnsDataByProjectId = projectId => {
    if (!ganttData) {
      return globalStore.getters['columns/getProjectById'](projectId);
    }

    return ganttData.projectColumns;
  };

  instance.ganttDataApi.getCustomColumnById = columnId => {
    if (!ganttData) {
      return globalStore.getters['columns/getCustomColumnById'](columnId);
    }

    return ganttData.сolumns?.find(col => +col.id === +columnId);
  };

  instance.ganttDataApi.getJiraColumnsByProjectId = projectId => globalStore.getters['columns/getJiraColumnsByProjectId'](projectId);

  instance.ganttDataApi.getColumnByName = (columnName, projectId) => {
    const activeProjectData = projectId ? instance.ganttDataApi.getProjectItem(projectId) : instance.ganttDataApi.getActiveProjectData();

    let columns = [];

    if (activeProjectData && activeProjectData.is_jira) {
      columns = instance.ganttDataApi.getJiraColumnsByProjectId(activeProjectData.gantt_id);
    } else if (!ganttData) {
      columns = globalStore.getters['columns/getStaticColumns'];
    } else {
      columns = ganttData.staticColumns;
    }

    return columns?.find(col => col.name === columnName) || null;
  };

  instance.ganttDataApi.getCustomColumnValuesByParams = (projectId, taskId, columnId) => {
    const project = instance.ganttDataApi.getProjectColumnsDataByProjectId(projectId);
    let result = [];

    if (!project?.columns.find(id => id === columnId)) return [];

    if (project && project.values) {
      result = project.values[taskId] || [];
    }

    return result.filter(o => o.column_id === columnId);
  };

  // instance.ganttDataApi.getCustomColumnValueByParams = (projectId, taskId, columnId) => {
  //   const project = instance.ganttDataApi.getProjectById(projectId);
  //   const column = instance.ganttDataApi.getCustomColumnById(columnId);
  //   let values = {};

  //   if (!project?.columns.find(id => id === columnId)) return [];

  //   const isOptionsTypeField = [1, 6, 7, 8, 9].includes(column.type);

  //   if (project && project.values) {
  //     values = project.values;
  //   }

  //   if (taskId && values[taskId]) {
  //     values = values[taskId];
  //   }

  //   if (columnId) {
  //     values = _.filter(values, o => {
  //       let additionalCondition = true;

  //       if (isOptionsTypeField) {
  //         additionalCondition = column.options.findIndex(opt => opt.id === +o.task_value) > -1;
  //       }

  //       return o.column_id === +columnId && additionalCondition;
  //     });
  //   }

  //   return values;
  // };

  instance.ganttDataApi.getUserCustomValuesMapByProjectId = projectId => {
    const project = instance.ganttDataApi.getProjectColumnsDataByProjectId(projectId);
    const columnsIds = project?.columns || [];
    const columnsMap = {};

    columnsIds.forEach(columnId => {
      columnsMap[columnId] = instance.ganttDataApi.getCustomColumnById(columnId);
    });

    if (!project) return {};

    const valuesMap = {};

    if (!project.values) return valuesMap;

    Object.keys(project.values).forEach(taskId => {
      const customColumnValues = project.values[taskId];

      customColumnValues.forEach(customColumnValueObject => {
        const column = columnsMap[customColumnValueObject.column_id];
        const isOptionsTypeField = column.type === 7 || column.type === 8 || column.type === 9;

        if (isOptionsTypeField) {
          if (valuesMap[`${taskId}-${customColumnValueObject.column_id}`]) {
            valuesMap[`${taskId}-${customColumnValueObject.column_id}`].push(customColumnValueObject.task_value);
          } else {
            valuesMap[`${taskId}-${customColumnValueObject.column_id}`] = [customColumnValueObject.task_value];
          }
        } else {
          valuesMap[`${taskId}-${customColumnValueObject.column_id}`] = customColumnValueObject.task_value;
        }
      });
    });

    return valuesMap;
  };

  instance.ganttDataApi.changeUserCustomValue = (task, columnId, value) => userCustomColumnsComponent.changeUserCustomValue(task, columnId, value);
}
